import { UserRoles } from '@/enums';
import { SoftwareLicenses } from '@/modules/software-licenses/types';

const access_roles = {
  [SoftwareLicenses.Pages.SOFTWARE_LICENSES]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
    UserRoles.Internal.PURCHASING_MANAGER,
  ],
  [SoftwareLicenses.Pages.SOFTWARE_LICENSE_DETAIL]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
    UserRoles.Internal.PURCHASING_MANAGER,
  ],
};

export default access_roles;
